import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { AppToaster } from '@components/shared/AppToaster'
import App from './App'
import './offline/hold'
import './i18n/index'
import '@fontsource-variable/figtree'
import 'maplibre-gl/dist/maplibre-gl.css'
import './index.css'
import { initTheme } from './utils/theme'
import { queryClient } from './services/queryClient'
import { loadPortalKind } from './utils/portalContext'

initTheme()

const rootEl = document.getElementById('root')
if (!rootEl) {
  document.body.innerHTML =
    '<pre style="color:red;padding:32px">FATAL: #root element not found in index.html</pre>'
  throw new Error('#root not found')
}

// Know the host kind (company or municipality) before the first render; never blocks for long or fails.
loadPortalKind().then(() => {
  try {
    ReactDOM.createRoot(rootEl).render(
      <React.StrictMode>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <App />
            <AppToaster />
          </QueryClientProvider>
        </BrowserRouter>
      </React.StrictMode>
    )
  } catch (err) {
    const msg = err instanceof Error ? err.stack ?? err.message : String(err)
    document.body.innerHTML = `<pre style="color:red;padding:32px;white-space:pre-wrap">RENDER ERROR:\n${msg}</pre>`
  }
})
